import { Dimmer, List, Loader, Modal } from '@mairistem/composants';
import type { Mouvement } from '@mairistem/comptabilite';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import { toast } from 'react-toastify';
import type ProfilEcriture from '../../../../interfaces/pieces/mouvements/profilEcriture';
import { getProfilsEcritureFrequent } from '../../../../services/piecesComptables/profilEcritures/profileEcrituresFrequents';
import { filterProfilsForMouvement } from '../../../../utils/mouvements/profilEcriture';

interface ProfilEcritureModalProps {
	codeGroupeProfilEcriture: string;
	identifiantEntite: number;
	mouvement: Mouvement;
	onClose: () => void;
	onSelect: (codeProfil: string) => void;
}

const getColor = (i: number) => {
	switch (i) {
		case 0:
			return '#D4AF37';
		case 1:
			return '#BFC1C2';
		default:
			return '#B08D57';
	}
};

const ProfilEcritureModal = ({
	codeGroupeProfilEcriture,
	identifiantEntite,
	mouvement,
	onClose,
	onSelect,
}: ProfilEcritureModalProps) => {
	const [loading, setLoading] = React.useState(false);
	const [profilsFrequent, setProfilsFrequent] = React.useState<
		ProfilEcriture[]
	>([]);

	// Chargement des profils d'écriture fréquents.
	const handleMount = async () => {
		if (codeGroupeProfilEcriture && identifiantEntite && mouvement?.sens) {
			setLoading(true);

			const searchParams = new URLSearchParams({
				'groupes[]': codeGroupeProfilEcriture,
				all: 'true',
				identifiantEntite: identifiantEntite.toString(),
				sens: mouvement?.sens,
				withProfil: 'true',
			});

			try {
				const { data } = await getProfilsEcritureFrequent(searchParams);
				// On transforme les profils frequents en profil
				const profilsFrequent: ProfilEcriture[] = data.map(
					(profilFrequent) => ({
						...profilFrequent.profil,
					}),
				);
				setProfilsFrequent(
					filterProfilsForMouvement(profilsFrequent, mouvement),
				);
			} catch {
				toast.error("Impossible de récupérer les profils d'écriture fréquent");
			} finally {
				setLoading(false);
			}
		}
	};

	return (
		<Modal
			closeIcon
			onClose={() => onClose()}
			onMount={() => handleMount()}
			open
			size="small"
		>
			<Modal.Header content="Profils d'écritures fréquents" />
			<Modal.Content>
				{loading ? (
					<Dimmer active inverted>
						<Loader active />
					</Dimmer>
				) : (
					<List animated divided relaxed="very" selection>
						{profilsFrequent.map((item, i) => (
							<List.Item
								key={item.identifiant}
								onClick={() => onSelect(item.code)}
							>
								{i < 3 && (
									<List.Content floated="right">
										<Icon color={getColor(i)} iconSet="Lucide" name="Medal" />
									</List.Content>
								)}
								<List.Header content={item.libelle} />
							</List.Item>
						))}
					</List>
				)}
			</Modal.Content>
		</Modal>
	);
};

export default ProfilEcritureModal;
